import { AlertBanner, AlertBannerText, Flex, Heading } from "monday-ui-react-core";
import styled from "styled-components";

import iconLocked from "@/assets/icons/locked.svg";

export function RestrictedAccess() {
  return (
    <Flex direction={Flex.directions.COLUMN} style={{ height: "100%" }}>
      <AlertBanner isCloseHidden={true}>
        <AlertBannerText text="Viewers and Guests cannot run ACLI." />
      </AlertBanner>
      <FlexGrow>
        <img src={iconLocked} alt="restricted access" />
        <Heading type={Heading.types.h2} value="Cannot let you in" style={{ margin: "var(--spacing-small)" }} />
        <span>Viewers and guests cannot run CLI - Automate Actions commands.</span>
      </FlexGrow>
    </Flex>
  );
}

const FlexGrow = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: var(--primary-text-color);
  font-family: var(--font-family);
  text-align: center;
  max-width: 320px;
  img {
    margin-bottom: 20px;
  }
  span {
    font-size: 16px;
    line-height: 24px;
    font-weight: 300;
  }
`;
